<script>
import { attributeService } from "../../services";
import { required,requiredIf} from "vuelidate/lib/validators";
import config from "../../config";
import { error_message, success_message } from "../../Helper/helper";
import Multiselect from "vue-multiselect";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import { numberLength,decimalNumber } from "../../Helper/formValidation";


export default {
  components: { attributeService, Multiselect, DropzonePopup,numberLength,decimalNumber },
    data() {
        return {
            checked: true,
            config: config,
            isLoading: false,
            att_type: "",
            boxCategories:[],
            typeform: {
                att_name: "",
                attribute_type: "",
                box_category: "",
                title_lang: "",
                image: "",
                price: "",
                quantity: "",
            },
        };
    },
    validations: {
        typeform: {
            att_name:{
                required,
            },
            attribute_type:{
                required,
            },
            box_category:{
                required : requiredIf(function(form){
                    return this.typeform.attribute_type == 'box';
                }),
            },
            price:{
                required : requiredIf(function(form){
                    return this.typeform.attribute_type == 'box';
                }),
            },
            title_lang:{
                required : requiredIf(function(form){
                    return this.typeform.attribute_type == 'box';
                }),
            },
            image:{
                required : requiredIf(function(form){
                    return this.typeform.attribute_type == 'box';
                }),
            },
            quantity:{
                required : requiredIf(function(form){
                    return this.typeform.attribute_type == 'box';
                }),
            },
        },
    },
    methods: {
        numberLength,
        decimalNumber,
        addAttribute(){
            this.$v.typeform.$touch();
            if (this.$v.typeform.$invalid) {
                return;
            } else {
                attributeService.addAttribute(this.typeform).then((response) => {
                    if (response.data.code === 200) {
                        var attribute_type = this.att_type;
                        success_message(response.data.message);
                        this.$router.push({ name: "attribute-list",query: {attribute_type} });
                    } else {
                        error_message(response.data.message);
                    }
                });
            }
        },
        alphabetic(e){   
            const floating = /^[A-Za-z ]+$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        floatingNumber(e){   
            const floating = /^[0-9.]\d*(\.\d{1,2})?$/;
            let char = String.fromCharCode(e.keyCode);
            if (floating.test(char)) return true;
            else e.preventDefault();
        },
        getAttributeType($event){
            this.typeform.att_name = '';
            this.typeform.box_category = '';
            this.typeform.title_lang = '';
            this.typeform.image = '';
            this.typeform.price = '';
            this.typeform.quantity = '';
            this.att_type = $event.target.value;
            if($event.target.value == 'box'){
                this.getCategoryBoxes();
            }
        },
        getCategoryBoxes(){
            attributeService
            .getallBoxCategory()
            .then((response) => {
               this.boxCategories = response.data.result;
            });
        }
    },
};

</script>
<template>
    <form @submit.prevent="addAttribute">
        <div class="card">
            <div class="card-body">
                <p class="card-title-desc"></p>
                <div class="row">
                    <div class="col-sm-6">
                        <div class="form-group">
                            <label class="required">{{ trans.get('__JSON__.Arrtibute Type') }}</label>
                            <select class="custom-select" v-model="typeform.attribute_type" :class="{ 'is-invalid': $v.typeform.attribute_type.$error }" @change="getAttributeType($event)">
                                <option value="" selected>{{ trans.get('__JSON__.Select Attribute Type') }}</option>
                                <option value="bottle">{{ trans.get('__JSON__.Bottle Deposit Price') }}</option>
                                <option value="box">{{ trans.get('__JSON__.Box Deposit Price') }}</option>
                                <option value="material">{{ trans.get('__JSON__.Material') }}</option>
                                <option value="size">{{ trans.get('__JSON__.Size') }}</option>
                                <option value="tax">{{ trans.get('__JSON__.Tax') }}</option>
                            </select>
                            <div v-if="$v.typeform.attribute_type.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.attribute_type.required">{{ trans.get('__JSON__.Please select attribute type') }}</span>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm-6" v-if="att_type != 'box'">
                        <div class="form-group">
                           <label class="required">{{ trans.trans('__JSON__.Attribute Value')}}</label>
                            <div v-if="att_type == 'bottle' || att_type == 'tax'">
                                <input
                                    maxlength="5"
                                    minlength="1"
                                    id="att_name"
                                    autocomplete="off"
                                    v-model="$v.typeform.att_name.$model"
                                    type="text"
                                    class="form-control"
                                    :placeholder="trans.trans('__JSON__.Attribute Value')"
                                    name="att_name"
                                    :class="{ 'is-invalid': $v.typeform.att_name.$error }"
                                    v-on:keypress="floatingNumber($event,typeform.att_name)"
                                />
                            </div>
                            <div v-else>
                                <input
                                    id="att_name"
                                    v-model="$v.typeform.att_name.$model"
                                    type="text"
                                    autocomplete="off"
                                    class="form-control"
                                    :placeholder="trans.trans('__JSON__.Attribute Value')"
                                    name="att_name"
                                    :class="{ 'is-invalid': $v.typeform.att_name.$error }"
                                />
                            </div>
                            
                            <div v-if="$v.typeform.att_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.att_name.required">{{ trans.get('__JSON__.Please enter attribute value') }}</span>
                            </div>
                            
                        </div>
                    </div>
                </div>
                <div class="row" v-if="att_type == 'box'">
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label class="required">{{ trans.trans('__JSON__.Box Category')}}</label>
                            <multiselect 
                                :multiple="false" 
                                v-model="$v.typeform.box_category.$model" 
                                label="title"
                                track-by="id"
                                :options="boxCategories" 
                                :class="{ 'is-invalid': $v.typeform.box_category.$error }"
                            >
                            </multiselect>
                            
                            <div v-if="$v.typeform.box_category.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.box_category.required">{{ trans.get('__JSON__.Please select box categoty') }}</span>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label class="required">{{ trans.trans('__JSON__.Box Name')}}</label>
                            <input
                                id="att_name"
                                autocomplete="off"
                                v-model="$v.typeform.att_name.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Box Name')"
                                name="att_name"
                                :class="{ 'is-invalid': $v.typeform.att_name.$error }"
                            />
                            
                            <div v-if="$v.typeform.att_name.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.att_name.required">{{ trans.get('__JSON__.Please add box name') }}</span>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label class="required">{{ trans.trans('__JSON__.Box Name (German)')}}</label>
                            <input
                                id="title_lang"
                                autocomplete="off"
                                v-model="$v.typeform.title_lang.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Box Name (German)')"
                                name="title_lang"
                                :class="{ 'is-invalid': $v.typeform.title_lang.$error }"
                            />
                            
                            <div v-if="$v.typeform.title_lang.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.title_lang.required">{{ trans.get('__JSON__.Please add box name') }}</span>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label class="required">{{ trans.trans('__JSON__.Quantity')}}</label>
                            <input
                                id="quantity"
                                autocomplete="off"
                                v-model="$v.typeform.quantity.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Quantity')"
                                name="quantity"
                                @keypress="numberLength($event,5)"
                                :class="{ 'is-invalid': $v.typeform.quantity.$error }"
                            />
                            
                            <div v-if="$v.typeform.quantity.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.quantity.required">{{ trans.get('__JSON__.Please add bottle quantity') }}</span>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label class="required">{{ trans.trans('__JSON__.Price')}}</label>
                            <input
                                id="price"
                                autocomplete="off"
                                v-model="$v.typeform.price.$model"
                                type="text"
                                class="form-control"
                                :placeholder="trans.trans('__JSON__.Price')"
                                name="price"
                                 @keypress="
                                decimalNumber($event)
                                "
                                :class="{ 'is-invalid': $v.typeform.price.$error }"
                            />
                            
                            <div v-if="$v.typeform.price.$error" class="invalid-feedback">
                                <span v-if="!$v.typeform.price.required">{{ trans.get('__JSON__.Please add box price') }}</span>
                            </div>
                            
                        </div>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group">
                        <label class="required">{{ trans.trans('__JSON__.Image')}}</label>
                            <dropzone-popup
                                v-model="$v.typeform.image.$model"
                                type="file"
                                id="image"
                                name="image"
                                acceptedFiles=".jpeg,.jpg,.png"
                            />
                            <div v-if="$v.typeform.image.$error" class="invalid-feedback cuisine-img">
                            <span v-if="!$v.typeform.image.required" >{{ trans.get('__JSON__.Please select image') }}.</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <button class="btn btn-primary mr-1 mt-3">{{ trans.get('__JSON__.Add Attribute') }}</button>
                        <b-button @click="$router.go(-1)" type="button" variant="secondary" class="mt-3">{{ trans.get('__JSON__.Cancel') }}</b-button>
                    </div>
                </div>
            </div>
        </div>
    </form>
</template>